import { api } from "@/api";

export const tagStore = {
  state: {
    tagCategories: [],
    inventoryTagOrders: [],
    tagCategoryTypes: [
      { value: 0, text: "Normale" },
      { value: 1, text: "Emplacement" }
    ]
  },
  getters: {
    getTagCategories(state) {
      return state.tagCategories;
    },
    getInventoryTagOrders(state) {
      return state.inventoryTagOrders;
    },
    getTagCategoryTypes(state) {
      return state.tagCategoryTypes;
    }
  },
  mutations: {
    setTagCategories(state, value) {
      state.tagCategories = value;
    },
    updateTagCategory(state, value) {
      state.tagCategories = state.tagCategories.filter(x => x.id !== value.id);
      state.tagCategories.push(value);
    },
    setInventoryTagOrders(state, value) {
      state.inventoryTagOrders = value;
    }
  },
  actions: {
    async loadTagCategories(context) {
      const res = await api.getTagCategories();
      context.commit(
        "setTagCategories",
        res.sort(x => x.display_order)
      );
    },
    async loadInventoryTagOrders(context) {
      const res = await api.getInventoryTagOrders();
      context.commit("setInventoryTagOrders", res);
    }
  }
};
